import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  & span.errorMessage {
    position: absolute;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 0 auto 0 auto;
  width: 80%;
`;

export const MiniLabel = styled.span`
  font-family: 'Roboto', arial, sans-serif;
  margin: 5px auto;
  color: ${({ theme }) => theme.grey};
`;
